// extracted by mini-css-extract-plugin
export var fadeInDown = "styles-module--fadeInDown--3c906";
export var firstGlow = "styles-module--first-glow--982e3";
export var mainTitle = "styles-module--main-title--059dd";
export var showMoreIcon = "styles-module--showMore-icon--e9bd8";
export var showMoreText = "styles-module--showMore-text--70c6a";
export var showMoreWrapper = "styles-module--showMore-wrapper--9580a";
export var suptitle = "styles-module--suptitle--051dc";